import { NKDatetimeModule } from 'ng2-datetime/ng2-datetime';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Project } from '../../../../classes/Project';
import { GlobalService } from '../../../services/global.service';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { DomSanitizer, DOCUMENT } from '@angular/platform-browser';

import { WindowRef } from '../../../../classes/windowRef';
import * as $ from 'jquery';

@Component({
  host: { '( document: scroll )': 'onScrollDocument( $event )' },
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {
  @ViewChild( 'scrolledTable' ) scrolledTable;
  @ViewChild( 'fixedTable' ) fixedTable;
  @ViewChild( 'tableWrapper' ) tableWrapper;

  sortingData = {
    field:      'updated_at',
    direction:  'DESC'
  };

  clients: any[] = [];

  contentVisible: boolean = false;
  clientsData: any[] = [];
  projectsData: any[] = [];
  salespersons: any[] = [];

  all_sales: string = '0.00';
  all_commission: string = '0.00';

  projects: any[] = [];
  projectStatuses: any = {
    newLead: 'New lead',
    leadLost: 'Lead lost',
    pendingManagerApproval: 'Pending manager approval',
    managerApproved: 'Manager approved',
    proposalSent: 'Proposal sent',
    invoiceSent: 'Invoice sent',
    depositReceived: 'Deposit received',
    installationPending: 'Installation pending',
    installationCompleted: 'Installation completed',
    purchaseOrderSent: 'Purchase order sent',
    productsShipped: 'Products shipped',
    productsReceived: 'Products received',
    paidInFull: 'Paid in full',
    projectCompleted: 'Project completed',
    projectCompletedRMARGA: 'Completed with RMA/RGA',
    projectCancelled: 'Project cancelled',
    other: 'Other'
  };

  isDisabledFilters: boolean = false;
  visibleScrolledTable: boolean = false;
  scrolledTableOffsetTop = 0;

  availableRoles: string[] = [ 'admin', 'sales', 'manager' ];
  isAvailable: boolean = true;

  paginationData = {
    count: 30,
    offset: 0,
    count_all: 0,
    currentPage: 1,
    maxPage: 1
  };

  filtersData = {
    adjustedAmount: '',
    adjustedProfit: '',
    comission_amount: '',
    active: '',
    inactiveProducts: '',
    client: '',
    Name: '',
    sales: '',
    status: '',
    owner: '',
    manager: '',
    balance: '',
    ProductCost: '',
    daysDue: '',
    dueTotal: '',
    Deposit: '',
    Profit: '',
    jobType: '',
    BuildingType: '',
    fromDate: undefined,
    toDate: undefined
  };

  datepickerFromOptions = {
    hideIcon: true,
    format: 'mm/dd/yyyy',
    placeholder: 'from'
  };
  datepickerToOptions = {
    hideIcon: true,
    format: 'mm/dd/yyyy',
    placeholder: 'to'
  };

  filtersTimeout: any;

  _date_from: any = '';
  _date_to: any = '';
  _old_from: any = ''
  _old_to: any = '';
  _was_matched_from: boolean = false;
  _was_matched_to: boolean = false;

  _scrollTop:number = 0;
  _scrollTopTimer:any = null;
  _scrollSystemInit: boolean = false;


  selectWidth: number = 160;

  selectParams: any = {

    client: {
      id: 'selectClient',
      id2: 'selectClientScrolled',
      width: this.selectWidth,
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.client = event.value; 
        this.changeFilters( );
      },
      options: [ { text: '', value: '' } ]
    },
    
    name: {
      id: 'selectName',
      id2: 'selectNameScrolled',
      width: this.selectWidth,
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.Name = event.value; 
        this.changeFilters( );
      },
      options: [ { text: '', value: '' } ]
    },
    
    sales: {
      id: 'selectSales',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.sales = event.value; 
        this.changeFilters( );
      },
      options: [ { text: '', value: '' } ]
    },

    deposit: {
      id: 'selectDepositType',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.Deposit = event.value; 
        this.changeFilters( );
      },
      options: [ 
        { text: '', value: '' },
        { text: 'Yes', value: 'Yes' },
        { text: 'No', value: 'No' }
      ]
    },

    status: {
      id: 'selectStatus',
      id2: 'selectStatusScrolled',
      width: this.selectWidth,
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.status = event.value; 
        this.changeFilters( );
      },
      options: [ 
        { text: '', value: '' },
        { value: "newLead", text: 'New lead' },
        { value: "leadLost", text: 'Lead lost' },
        { value: "pendingManagerApproval", text: 'Pending manager approval' },
        { value: "managerApproved", text: 'Manager approved' },
        { value: "proposalSent", text: 'Proposal sent' },
        { value: "depositReceived", text: 'Deposit received' },
        { value: "invoiceSent", text: 'Invoice sent' },
        { value: "purchaseOrderSent", text: 'Purchase order sent' },
        { value: "productsShipped", text: 'Products shipped' },
        { value: "productsReceived", text: 'Products received' },
        { value: "paidInFull", text: 'Paid in full' },
        { value: "installationPending", text: 'Installation pending' },
        { value: "installationCompleted", text: 'Installation completed' },
        { value: 'projectCompleted', text: 'Project completed' },
        { value: 'projectCompletedRMARGA', text: 'Project completed with RMA/RGA' },
        { value: 'projectCancelled', text: 'Project cancelled' },
        { value: "other", text: 'Other' }
      ]
    },

    active: {
      id: 'selectActive',
      id2: 'selectActiveScrolled',
      isDisabled: this.isDisabledFilters,
      width: this.selectWidth,
      change: ( event ) => { 
        this.filtersData.active = event.value; 
        this.changeFilters( );
      },
      options: [ 
        { text: '', value: '' },
        { text: 'Active', value: 'true' },
        { text: 'Inactive', value: 'false' }
      ]
    },

    inactiveProducts: {
      id: 'selectInactiveProducts',
      id2: 'selectInactiveProductsScrolled',
      isDisabled: this.isDisabledFilters,
      width: this.selectWidth,
      change: ( event ) => { 
        this.filtersData.inactiveProducts = event.value; 
        this.changeFilters( );
      },
      options: [ 
        { text: '', value: '' },
        { text: 'Yes', value: 'true' },
        { text: 'No', value: 'false' }
      ]
    }

  };


  constructor ( 
    @Inject(DOCUMENT) private document: Document,
    private model: ModelService,
    private global: GlobalService,
    private winRef: WindowRef,
    private loginService: LoginService,
    private sanitizer: DomSanitizer ) {
    this.global.setDocumentTitle( 'Projects' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
  }


  ngOnInit ( ) {

    this.model.getProjectsListData( ( prData ) => {
      prData = prData.json( );
      this.projects = prData.projects;
      prData.projects.forEach( _pr => { this.selectParams.name.options.push( { text: _pr.Name, value: _pr.id } ); });
    });

    this.model.getClientsData( ( clientsData ) => {
      this.clients = clientsData;
      clientsData.forEach( _cl => { this.selectParams.client.options.push( { text: _cl.FirstName + ' ' + _cl.LastName, value: _cl.id } ); });
    }, 'Company' );

    this.model.getUsersData( ( usersData ) => {
      usersData = usersData.json( );
      this.salespersons = usersData.users;
      usersData.users.forEach( _sp => { 
        this.selectParams.sales.options.push( { text: _sp.firstName + ' ' + _sp.secondName, value: _sp.id } ); 
      });
    }, { status: 'active', not_empty_name: 'true' });

  }

  ngAfterViewInit ( ) {
    let _sorting = localStorage.getItem( 'sortingProjectsList' );
    let _filters = localStorage.getItem( 'filtersProjectsList' );
    let _pagination = localStorage.getItem( 'paginationProjectsList' );
    let _scroll = localStorage.getItem( 'scrollProjectsList' );
    if ( _sorting ) this.sortingData = JSON.parse( _sorting );
    if ( _filters ) this.filtersData = JSON.parse( _filters );
    if ( _pagination ) this.paginationData = JSON.parse( _pagination );
    if ( _scroll ) this._scrollTop = +_scroll;
    if ( this.filtersData.fromDate || this.filtersData.fromDate === '' ) this._date_from = this.global.parseDate( this.filtersData.fromDate );
    if ( this.filtersData.toDate || this.filtersData.toDate === '' ) this._date_to = this.global.parseDate( this.filtersData.toDate );
    this.loadData( null, this._scrollIntoView( ) );
  }

  onScrollDocument ( event ) {

    clearTimeout( this._scrollTopTimer );
    this._scrollTopTimer = setTimeout( ( ) => {
      if ( this._scrollSystemInit || this._scrollTop != 0 ) {
        localStorage.setItem( 'scrollProjectsList', this.winRef.nativeWindow.scrollY );
      } else {
        this._scrollSystemInit = true;
      }
    }, 350);

    let headerHeight = 71;
    let _wrapper = this.document.getElementsByClassName('scrolled-table--wrapper')[0];

    // Fixing of header height
    if ( this.global.displayWidth < 768 ) headerHeight = 51;

    if ( this.fixedTable && this.tableWrapper ) {

      if ( event.target.scrollingElement.scrollTop > headerHeight + this.tableWrapper.nativeElement.offsetTop ) {
        this.visibleScrolledTable = true;
        if ( _wrapper ) _wrapper.scrollLeft = this.tableWrapper.nativeElement.scrollLeft;
      } else {
        this.visibleScrolledTable = false;
      }

    } else {
      this.visibleScrolledTable = false;
    }
    
  }

  onHorizontalScroll ( event ) {

    if ( this.scrolledTable && this.fixedTable && this.tableWrapper ) {
      this.document.getElementsByClassName('scrolled-table--wrapper')[0].scrollLeft = this.tableWrapper.nativeElement.scrollLeft;
    }

  }

  changePage ( page ) {
    this.paginationData.currentPage = page;
    this.paginationData.offset = (page-1) * this.paginationData.count;
    localStorage.setItem( 'paginationProjectsList', JSON.stringify( this.paginationData ) );
    this.loadData( false );
    $('html,body').animate({ scrollTop: 0 }, 'slow');
  }


  changeSorting ( _sortField ) {

    if ( _sortField != this.sortingData.field ) {
      this.sortingData.field = _sortField;
      this.sortingData.direction = 'ASC';
    } else {
      this.sortingData.direction = ( this.sortingData.direction == 'ASC' ) ? 'DESC' : 'ASC';
    }

    this.paginationData.offset = 0;
    this.paginationData.currentPage = 1;

    localStorage.setItem( 'sortingProjectsList', JSON.stringify( this.sortingData ) );
    localStorage.setItem( 'paginationProjectsList', JSON.stringify( this.paginationData ) );

    this.loadData( );

  }

  _scrollIntoView ( ) {
    // Code to scroll window
    setTimeout( ( ) => {
      this.winRef.nativeWindow.scrollTo( 0, this._scrollTop );
    }, 1500 );
  }

  toggleClient ( clientName ) {

    for ( let i = 0; i < this.clientsData.length; ++i ) {
      if ( this.clientsData[i].name == clientName ) {
        this.clientsData[i].toggle = !this.clientsData[i].toggle;
        break;
      }
    }

  }

  changeFilters ( clearing?:boolean ) {

    clearTimeout( this.filtersTimeout );
    this.filtersTimeout = setTimeout( ( ) => {
      this.paginationData.offset = 0;
      this.paginationData.currentPage = 1;
      if ( clearing !== true ) {
        localStorage.setItem( 'filtersProjectsList', JSON.stringify( this.filtersData ) );
        localStorage.setItem( 'paginationProjectsList', JSON.stringify( this.paginationData ) );
      } else {
        localStorage.removeItem( 'sortingProjectsList' );
        localStorage.removeItem( 'filtersProjectsList' );
        localStorage.removeItem( 'paginationProjectsList' );
      }
      // this.isDisabledFilters = true;
      if ( clearing == true ) this.loadData( false );
      else this.loadData( );
    }, 350 );

  }

  clearFilters ( ) {
    this.filtersData = {
      adjustedAmount: '',
      adjustedProfit: '',
      comission_amount: '',
      active: '',
      inactiveProducts: '',
      client: '',
      Name: '',
      sales: '',
      status: '',
      owner: '',
      manager: '',
      ProductCost: '',
      balance: '',
      daysDue: '',
      dueTotal: '',
      Deposit: '',
      Profit: '',
      jobType: '',
      BuildingType: '',
      fromDate: '',
      toDate: ''
    };
    this._date_from = '';
    this._date_to = '';
    this.sortingData = {
      field:       'updated_at',
      direction:   'DESC'
    };
    this.changeFilters( true );
  }


  handleDateFromChange ( $event ) {
    if ( $event === undefined ) return;
    let _date = ( $event.getMonth( ) + 1 ) + '/' + $event.getDate( ) + '/' + $event.getFullYear( );

    this.filtersData.fromDate = _date;
    this._old_from = _date;
    this._was_matched_from = true;
    this.changeFilters( );
    
  }
  handleDateToChange ( $event ) {
    if ( $event === undefined ) return;
    let _date = ( $event.getMonth( ) + 1 ) + '/' + $event.getDate( ) + '/' + $event.getFullYear( );

    this.filtersData.toDate = _date;
    this._old_to = _date;
    this._was_matched_to = true;
    this.changeFilters( );
    
  }

  changeDatePickerFrom ( _value, _ref ) {
    if ( _value === undefined ) return;
    _ref.filtersData.fromDate = '';
    
    if ( _value.match( /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/ ) ) {
      if ( _value != _ref._old_from ) {
        _ref._old_from = _value;
        _ref._was_matched_from = true;
        _ref.filtersData.fromDate = _value;
        _ref.changeFilters( );
      }
    } else {
      if ( _ref._was_matched_from == true ) {
        _ref._old_from = _value;
        _ref._was_matched_from = false;
        _ref.changeFilters( );
      }
    }
  }
  changeDatePickerTo ( _value, _ref ) {
    if ( _value === undefined ) return;

    _ref.filtersData.toDate = '';
    
    if ( _value.match( /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/ ) ) {
      if ( _value != _ref._old_to ) {
        _ref._old_to = _value;
        _ref._was_matched_to = true;
        _ref.filtersData.toDate = _value;
        _ref.changeFilters( );
      }
    } else {
      if ( _ref._was_matched_to == true ) {
        _ref._old_to = _value;
        _ref._was_matched_to = false;
        _ref.changeFilters( );
      }
    }
  }

  projectRedirect ( id ) {
    this.global.redirect( '/project-detail/'+id );
  }

  loadData ( _withoutPreloader?, cb? ) {

    let requestData = {};
    let withoutPreloader = true;
    if ( _withoutPreloader === false ) withoutPreloader = false;

    requestData['sorting'] = this.sortingData;
    requestData['pagination'] = this.paginationData;
    requestData['filters'] = this.filtersData;

    this.model.getProjectsDataTable( ( prData, paginationData, sortingData, filtersData, all_commission, all_sales ) => {
      this.contentVisible = true;
      this.paginationData = paginationData;
      this.projectsData = prData;
      // this.isDisabledFilters = false;
      // this.contentVisible = true;
      // this.checkEqualityFilters( response.filters );
      // this.projectsData = response.data;
      // this.sortingData = response.sorting;
      this.sortingData = sortingData;
      this.paginationData = paginationData;
      this.filtersData = filtersData;
      this.all_sales = all_sales;
      this.all_commission = all_commission;
      // this.filtersData = response.filters;
      if ( cb ) cb( );
    }, false, requestData, withoutPreloader );

  }



}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/projects/projects/projects.component.ts